import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const SUBJECTS = ['General Inquiry','Tour Booking','Custom Itinerary','Houseboat Booking','Taxi / Transfer','Feedback','Other'];

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', phone:'', subject:'General Inquiry', message:'' });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handle = async e => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post('/api/contacts', form);
      setSuccess(true);
    } catch { } finally { setSubmitting(false); }
  };

  return (
    <div>
      {/* Hero */}
      <div className="page-hero" style={{ backgroundImage:"url('https://images.unsplash.com/photo-1564327287902-0ccf559d839e?w=1600&q=85')" }}>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="breadcrumb">
            <Link to="/">Home</Link><span className="breadcrumb-sep">›</span><span>Contact</span>
          </div>
          <h1>Get in Touch</h1>
          <p>Our Kashmir travel experts are here to help you plan the perfect trip. We typically respond within 2 hours.</p>
        </div>
      </div>

      <section className="section" style={{ background:'var(--bg)', paddingTop:'3rem' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1.5fr', gap:'3.5rem', alignItems:'start' }}>

            {/* Contact Info */}
            <div>
              <span className="section-label">Reach Us</span>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:'2rem', marginBottom:'0.75rem' }}>We'd Love to<br/>Hear From You</h2>
              <div className="divider" />
              <p style={{ lineHeight:1.8, marginBottom:'2rem', color:'var(--body)' }}>
                Whether you're planning a honeymoon, family vacation, or adventure trek — we're here to make your Kashmir dream a reality.
              </p>

              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div>
                  <div className="contact-info-label">Phone / WhatsApp</div>
                  <div className="contact-info-value">+91 7006478276</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>Available 24×7</div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">✉️</div>
                <div>
                  <div className="contact-info-label">Email</div>
                  <div className="contact-info-value">querytoursandtravels@gmail.com</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>Reply within 2 hours</div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div>
                  <div className="contact-info-label">Office</div>
                  <div className="contact-info-value">Dal Lake Road, Boulevard</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>Srinagar, J&K 190001</div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">🕐</div>
                <div>
                  <div className="contact-info-label">Working Hours</div>
                  <div className="contact-info-value">Mon–Sat: 8AM – 9PM</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--muted)' }}>Sun: 9AM – 6PM (Emergency: 24×7)</div>
                </div>
              </div>

              {/* Social */}
              <div style={{ marginTop:'2rem', padding:'1.5rem', background:'var(--surface)', borderRadius:'var(--radius-lg)', border:'1px solid var(--border)' }}>
                <div style={{ fontFamily:"'Poppins',sans-serif", fontWeight:700, fontSize:'0.85rem', color:'var(--heading)', marginBottom:'1rem', textTransform:'uppercase', letterSpacing:'0.08em' }}>Follow Our Journeys</div>
                <div style={{ display:'flex', gap:'0.75rem' }}>
                  {[['📸','Instagram','https://instagram.com'],['📘','Facebook','https://facebook.com'],['▶️','YouTube','https://youtube.com'],['🐦','Twitter','https://twitter.com']].map(([icon, name, url], i) => (
                    <a key={i} href={url} target="_blank" rel="noopener noreferrer"
                      style={{ width:44, height:44, borderRadius:10, background:'rgba(15,76,129,0.08)', color:'var(--primary)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.2rem', transition:'all 0.2s', border:'1px solid rgba(15,76,129,0.12)' }}
                      title={name}
                      onMouseEnter={e => { e.currentTarget.style.background='var(--primary)'; e.currentTarget.style.color='#fff'; }}
                      onMouseLeave={e => { e.currentTarget.style.background='rgba(15,76,129,0.08)'; e.currentTarget.style.color='var(--primary)'; }}>
                      {icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Form */}
            <div style={{ background:'var(--surface)', borderRadius:'var(--radius-lg)', padding:'2.5rem', boxShadow:'var(--shadow-md)', border:'1px solid var(--border)' }}>
              {success ? (
                <div style={{ textAlign:'center', padding:'3rem 1rem' }}>
                  <div style={{ fontSize:'4rem', marginBottom:'1.25rem' }}>✅</div>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", color:'var(--heading)', marginBottom:'0.75rem' }}>Message Sent!</h3>
                  <p style={{ lineHeight:1.8, marginBottom:'2rem', maxWidth:380, margin:'0 auto 2rem' }}>Thank you for reaching out! Our Kashmir travel experts will get back to you within 2 hours.</p>
                  <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
                    <button className="btn btn-outline" onClick={() => { setSuccess(false); setForm({ name:'', email:'', phone:'', subject:'General Inquiry', message:'' }); }}>Send Another</button>
                    <a href="https://wa.me/917006478276" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">💬 WhatsApp Us</a>
                  </div>
                </div>
              ) : (
                <>
                  <h3 style={{ fontFamily:"'Playfair Display',serif", color:'var(--heading)', marginBottom:'0.5rem' }}>Send us a Message</h3>
                  <p style={{ fontSize:'0.9rem', color:'var(--muted)', marginBottom:'2rem' }}>Fill in the form below and we'll get back to you shortly.</p>
                  <form onSubmit={handle}>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginBottom:'1rem' }}>
                      <div>
                        <label className="input-label">Full Name *</label>
                        <input className="input" required placeholder="Your full name" value={form.name} onChange={e => setForm(f => ({...f, name:e.target.value}))} />
                      </div>
                      <div>
                        <label className="input-label">Phone Number</label>
                        <input className="input" placeholder="+91 7006478276" value={form.phone} onChange={e => setForm(f => ({...f, phone:e.target.value}))} />
                      </div>
                    </div>
                    <div style={{ marginBottom:'1rem' }}>
                      <label className="input-label">Email Address *</label>
                      <input className="input" type="email" required placeholder="your@email.com" value={form.email} onChange={e => setForm(f => ({...f, email:e.target.value}))} />
                    </div>
                    <div style={{ marginBottom:'1rem' }}>
                      <label className="input-label">Subject</label>
                      <select className="input" value={form.subject} onChange={e => setForm(f => ({...f, subject:e.target.value}))}>
                        {SUBJECTS.map(s => <option key={s}>{s}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom:'1.75rem' }}>
                      <label className="input-label">Message *</label>
                      <textarea className="input" required rows="5" placeholder="Tell us about your travel plans, dates, group size, special requirements..." value={form.message} onChange={e => setForm(f => ({...f, message:e.target.value}))} />
                    </div>
                    <button type="submit" className="btn btn-primary btn-lg w-full" style={{ justifyContent:'center' }} disabled={submitting}>
                      {submitting ? '⏳ Sending...' : '✦ Send Message'}
                    </button>
                    <p style={{ textAlign:'center', fontSize:'0.78rem', color:'var(--muted)', marginTop:'0.85rem' }}>
                      By submitting you agree to our Privacy Policy.
                    </p>
                  </form>
                </>
              )}
            </div>
          </div>

          {/* Map Placeholder */}
          <div style={{ marginTop:'4rem', borderRadius:'var(--radius-xl)', overflow:'hidden', height:360, background:'var(--surface)', border:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'1rem' }}>
            <div style={{ fontSize:'3rem' }}>🗺️</div>
            <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--heading)' }}>Query Tours and Travels Office</div>
            <div style={{ fontSize:'0.9rem', color:'var(--muted)' }}>Dal Lake Road, Boulevard, Srinagar, J&K 190001</div>
            <a href="https://maps.google.com/?q=Dal+Lake+Srinagar" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm">Open in Google Maps</a>
          </div>
        </div>
      </section>

      <a href="https://wa.me/917006478276" target="_blank" rel="noopener noreferrer" className="whatsapp-fab">💬</a>

      <style>{`
        @media (max-width:900px) {
          section .container > div[style*="grid-template-columns: 1fr 1.5fr"] { grid-template-columns: 1fr !important; }
          div[style*="grid-template-columns: 1fr 1fr"] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
